module.exports = __webpack_public_path__ + "img/2.1ab2d220.png";